import { create } from 'zustand';

interface SessionState {
  userId: string | null;
  token: string | null;
  ranked: boolean;
  consentRecorded: boolean;
  set(input: Partial<Omit<SessionState, 'set' | 'clear'>>): void;
  clear(): void;
}

const STORAGE_KEY = 'auramegle.session';

function load(): Partial<SessionState> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Partial<SessionState>;
  } catch {
    return {};
  }
}

function save(s: SessionState): void {
  try {
    const { userId, token, ranked, consentRecorded } = s;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ userId, token, ranked, consentRecorded }),
    );
  } catch {
    // ignore
  }
}

const initial = load();

export const useSession = create<SessionState>((set, get) => ({
  userId: initial.userId ?? null,
  token: initial.token ?? null,
  ranked: initial.ranked ?? false,
  consentRecorded: initial.consentRecorded ?? false,
  set(input) {
    set(input);
    save(get());
  },
  clear() {
    set({ userId: null, token: null, ranked: false, consentRecorded: false });
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  },
}));
